var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_5927fff2"]},_vm.$listeners),[_c('cube-button',{attrs:{"primary":"","icon":"like"}},[_vm._v("图标按钮")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }